module.exports = __webpack_public_path__ + "2281523697d6d4ae4343f224cc672d8b.png";